export function useFieldValue() {
  const getFieldNameValue = (props, e, doubleValue) => {
    const data = { name: props.name, value: "" };

    if (props.type === "phone_number" || props.type === "phone") {
      data["value"] = e.value.replace(/\D/g, "");
    } else if (props.type === "currency") {
      data["value"] = doubleValue;
    } else if (props.type === "date") {
      const date = new Date(e);
      data["value"] = `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()}`;
    } else if(props.type === "cnpj"){
      data["value"] = e.target.value.replace(/\D+/g, "")
    } else {
      data["value"] = e.target.value;
    }
    return data;
  };

  return [getFieldNameValue];

}


// WEBPACK FOOTER //
// ./src/_components/Input/hooks/index.js